import { get, post } from '../utils/request';
import { credentials } from './user';

export const handleFetchStoreProductCategories = (user) => async (dispatch) => {
  try {
    const response = await get('/store_product_categories', dispatch, credentials(user));
    const body = await response.json();
    const { categories } = body;
    dispatch(setStoreProductCategories(categories));
    return categories;
  } catch (error) {
    return false;
  }
};

export const setStoreProductCategories = (storeProductCategories) => ({
  type: 'SET_STORE_PRODUCT_CATEGORIES',
  storeProductCategories,
});

export const handleFetchStoreProductProviders = (user) => async (dispatch) => {
  try {
    const response = await get('/store_product_providers', dispatch, credentials(user));
    const body = await response.json();
    const { providers } = body;
    dispatch(setStoreProductProviders(providers));
    return providers;
  } catch (error) {
    return false;
  }
};

export const setStoreProductProviders = (storeProductProviders) => ({
  type: 'SET_STORE_PRODUCT_PROVIDERS',
  storeProductProviders,
});

export const handleFetchStoreProducts = (params, user) => async (dispatch) => {
  try {
    const response = await post('/search_store_product', params, dispatch, credentials(user));

    const body = await response.json();

    const { results } = body;

    dispatch(setStoreProducts(results || []));

    // Renvoie les résultats (et plus seulement true) pour que la recherche inline
    // du catalogue (ProductSearchField) puisse les utiliser directement. Les anciens
    // appelants testent `if (!result)` : un tableau (même vide) reste truthy =
    // succès, et l'échec réseau renvoie toujours false (catch).
    return results || [];
  } catch (error) {
    return false;
  }
};

export const setStoreProducts = (storeProducts) => ({
  type: 'SET_STORE_PRODUCTS',
  storeProducts,
});

export const resetStoreProducts = () => ({
  type: 'RESET_STORE_PRODUCTS',
});
